import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Alert, Button, Drawer, Field, Input } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const NewBuildDrawer = ({ guid, onClose, onSave, show }) => {
  const [github_release_version, setGithubReleaseVersion] = useState('');
  const [error_message, setErrorMessage] = useState(null);

  const createBuild = () => {
    Api.buildCreate({ mobile_app_guid: guid, github_release_version })
      .then(() => {
        onSave();
      })
      .catch(() => {
        setErrorMessage('There was an error creating the Build');
      });
  };

  const _handleSelection = e => {
    setGithubReleaseVersion(e.target.value);
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={createBuild}>Create New Build</Button>}
      onClose={onClose}
      show={show}
      title='New Build'
    >
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      <Field
        description='This should match a release or branch name in the hms-victory code respository'
        label='Release Version'
      >
        <Input onChange={_handleSelection} value={github_release_version} />
      </Field>
    </Drawer>
  );
};

NewBuildDrawer.propTypes = {
  guid: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default NewBuildDrawer;
